import WebpTexture from '../../../../ui-textures/wepp-texture'
import { DynamicThumbnailService } from '../../../dynamic-thumbnail-service'
import ExpandableTileLandscape from './ExpandableTileLandscape'

export default class ExpandableTileLandscapeLive extends ExpandableTileLandscape {
    _dynamicUrl: string | null = null
    _onDynamicImage: ((image: string) => void) | null = null
    _onDefaultSettled: (() => void) | null = null
    _pendingDynamicImage = ''
    _defaultSettled = false

    trySetDynamicImgSrc(url: string) {
        const artwork = this.tag('Wrapper').tag('Artwork')
        if (!artwork) return
        if (!this._defaultSettled) {
            this._pendingDynamicImage = url
            return
        }
        this._pendingDynamicImage = ''
        const w = this.isNumberRow ? this.w - 180 : this.w
        this._imgSrc = url
        artwork.patch({
            x: w / 2,
            y: this.h / 2,
            mount: 0.5,
            w: w,
            h: this.h,
            texture: {
                type: WebpTexture,
                src: url,
            },
        })
    }

    _watchDefaultImage() {
        const artwork = this.tag('Wrapper').tag('Artwork')
        this._defaultSettled = !this._imgSrc || !artwork || !!artwork.displayedTexture
        if (this._defaultSettled) return
        this._onDefaultSettled = () => {
            this._clearDefaultImageWatch()
            this._defaultSettled = true
            if (this._pendingDynamicImage) this.trySetDynamicImgSrc(this._pendingDynamicImage)
        }
        artwork.on('txLoaded', this._onDefaultSettled)
        artwork.on('txError', this._onDefaultSettled)
    }

    _clearDefaultImageWatch() {
        if (!this._onDefaultSettled) return
        const artwork = this.tag('Wrapper').tag('Artwork')
        if (artwork) {
            artwork.off('txLoaded', this._onDefaultSettled)
            artwork.off('txError', this._onDefaultSettled)
        }
        this._onDefaultSettled = null
    }

    override _attach() {
        super._attach()
        const url = this._itemNode?.dynamic_image
        const w = this.isNumberRow ? this.w - 180 : this.w
        if (
            this._itemNode?.enableDynamicThumbnail &&
            url &&
            DynamicThumbnailService.isEligible(
                this.rowType,
                w,
                this.h,
                this.fireAncestors('$rowGrid'),
            )
        ) {
            this._watchDefaultImage()
            this._dynamicUrl = url
            this._onDynamicImage = (image: string) => this.trySetDynamicImgSrc(image)
            DynamicThumbnailService.register(url, this._onDynamicImage)
        }
    }

    override _detach() {
        super._detach()
        this._clearDefaultImageWatch()
        this._pendingDynamicImage = ''
        this._defaultSettled = false
        if (this._dynamicUrl && this._onDynamicImage) {
            DynamicThumbnailService.unregister(this._dynamicUrl, this._onDynamicImage)
            this._dynamicUrl = null
            this._onDynamicImage = null
        }
    }
}
